import { Map, List } from 'immutable';

import InsightProduct from 'models/InsightProductModel';
import { createReducer } from '../../utils/helpers';

import {
  REQUEST_MONITOR_PRODUCT_MATCHES,
  REQUEST_MONITOR_PRODUCT_MATCHES_SUCCESS,
  REQUEST_MONITOR_PRODUCT_MATCHES_FAILURE,
} from './types';

// Shape of the reducer
// [insightId]: {
//     data: [],
//     network: { loading: false, error: false }
// },
const initialState = Map();

export function monitorProductMatchesRequest(insightId, payload) {
  return {
    type: REQUEST_MONITOR_PRODUCT_MATCHES,
    insightId,
    payload,
  };
}

export function monitorProductMatchesSuccess(insightId, response) {
  return {
    type: REQUEST_MONITOR_PRODUCT_MATCHES_SUCCESS,
    insightId,
    response,
  };
}

export function monitorProductMatchesFailure(insightId, error) {
  return {
    type: REQUEST_MONITOR_PRODUCT_MATCHES_FAILURE,
    insightId,
    error,
  };
}

export default createReducer(initialState, {
  [REQUEST_MONITOR_PRODUCT_MATCHES]: (state, action) =>
    state.setIn([action.insightId, 'network', 'loading'], true),
  [REQUEST_MONITOR_PRODUCT_MATCHES_SUCCESS]: (state, action) =>
    state.withMutations((s) =>
      s
        .setIn([action.insightId, 'network', 'loading'], false)
        .setIn([action.insightId, 'network', 'error'], false)
        .setIn([action.insightId, 'data'], List(action.response.map(InsightProduct.deserialize))),
    ),
  [REQUEST_MONITOR_PRODUCT_MATCHES_FAILURE]: (state, action) =>
    state.withMutations((s) =>
      s
        .setIn([action.insightId, 'network', 'loading'], false)
        .setIn([action.insightId, 'network', 'error'], action.error),
    ),
});
